interface DropdownOption {
  label: string;
  value: string;
}

interface EntityWithId {
  id: string;
}

/**
 * Filters out the current entity from a list of entities and converts them to dropdown options.
 * Prevents self-reference in parent selection dropdowns.
 * 
 * @param allEntities - Array of all available entities
 * @param currentEntity - The current entity to exclude (optional, for create mode)
 * @param labelFormatter - Function to format the label for each entity
 * @returns Array of dropdown options excluding the current entity
 */
export function getParentOptions<T extends EntityWithId>(
  allEntities: T[],
  currentEntity: T | undefined,
  labelFormatter: (entity: T) => string
): DropdownOption[] {
  const availableEntities = allEntities.filter(entity => entity.id !== currentEntity?.id);
  
  return availableEntities.map(entity => ({
    label: labelFormatter(entity),
    value: entity.id
  }));
}
